module.exports = __webpack_public_path__ + "static/media/spell-check.480170ca.svg";